import {IApiClientInput, ITrackingTransformationInput} from '../types';

const trackEventMutation = /* GraphQL */ `
  mutation trackEvent($trackingId: String!, $appName: String!, $rawEvent: String!) {
    trackEvent(tracking_id: $trackingId, appName: $appName, rawEvent: $rawEvent) {
      success
    }
  }
`;

const graphqlTransformer = ({
  apiUrl,
  eventName,
  namespace,
  properties,
  trackingId,
}: ITrackingTransformationInput): IApiClientInput => {
  const data = {
    query: trackEventMutation,
    variables: {
      appName: namespace,
      rawEvent: JSON.stringify({
        category: namespace,
        event: eventName,
        ...properties,
      }),
      trackingId,
    },
  };

  return {url: apiUrl, data};
};

export default graphqlTransformer;
